import styled from 'styled-components';

export const Title = styled.h6`
  color: #acacac;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.div`
  margin-right: 20px;
`;

export const GroupWrapper = styled.div`
  margin-top: 1em;
  padding: 0 1rem 1rem 1rem;
  background-color: #f5f6f7;
  border: 1px solid #e2e2e2;
`;

export const GroupTitle = styled.div`
  margin-top: 20px;
`;

export const StatusBarWrapper = styled.div`
  width: 100%;
  padding: 20px 0 20px 20px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  opacity: 1;
  color: #111111;
  z-index: 1;
  font-weight: 700;
  border-top: 5px solid #4b286d;
`;

export const DueMonthlyWrapper = styled.div`
  display: inline-block;
  padding: 0 20px 0 0;
  // height: 100px;
  vertical-align: top;
  margin-bottom:10px;
`;

export const DueMonthlyText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const Amount = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
`;

export const DueNowWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px;
  // height: 100px;
  border-left: solid 1px #acacac;
  vertical-align: top;
`;

export const DueNowText = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px 0 0;
`;

export const ButtonsWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em
  height: 100px;
  vertical-align: top;
`;

export const LabelDueMonthly = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
  display: block;
`;

export const BeforeTaxesLabel = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
`;

export const PricingBlockMain = styled.div`
  display: flex;
  float: none;
`;

export const IntegralPart = styled.span`
  font-size: 1.75rem;
  font-weight: 400;
  color: #2a2c2e;
`;

export const FractionalPart = styled.span`
  font-size: 1rem;
  top: -9.25px;
  position: relative;
  font-weight: 500;
`;

export const Currency = styled.span`
  position: relative;
  font-size: 1rem;
  top: 4.5px;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
  font-weight: 500;
  color: #2a2c2e;
`;

export const TimesMonth = styled.span`
  font-size: 12px;
  font-weight: 500;
  margin-left: 0.5rem;
  margin-top: 1.5rem;
`;

export const Heading = styled.h4`
  color: #4b286d;
  font-weight: 700;
`;

export const ActionButton = styled.button`
  display: inline-block;
  padding: 0;
  font-weight: 400;
  text-align: left;
  text-decoration: underline;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s;
  color: #4b286d;
`;

export const CurrentSubscriberSummaryContainer = styled.div`
  width: 450px;
  margin: 1rem;
  box-shadow: 0 0 20px #cccccc;
  height: fit-content;
`;

export const CurrentSubscriberHeader = styled.div`
  padding: 0.5rem 1rem;
  background: #4b286d;
  color: #fff;
  font-weight: 500;
`;

export const CurrentSubscriberMain = styled.div`
  padding: 0.5rem 1rem;
`;

export const DueLabel = styled.h4`
  font-weight: 500;
  color: #4b286d;
`;

export const CurrentSubscriberPricingMain = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid;
  font-size: 20px;
  padding-bottom: 0.5rem;
  margin: 1rem 0;
`;

export const SummaryLineItemMain = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  padding: 0.25rem;
`;

export const SummaryLineItemName = styled.span`
  margin-right: 1rem;
`;

export const SummaryAmountAdd = styled.span`
  color: green;
`;
export const SummaryAmountSubtract = styled.span`
  color: red;
`;
